<template>
  <section id="admin-server-list">
    <b-card class="admin-page-mobile">
        <b-button
            class="btn-sm mb-1"
            :variant="isMobile ? 'outline-light': 'outline-primary'"
          @click="showModal"
        >
          <feather-icon
              icon="PlusIcon"
              size="22"
              class="align-text-top"
          /> افزودن
        </b-button>

        <v-data-table
            v-bind="{dark : isMobile }"
          :headers="headers"
          :items="desserts"
          mobile-breakpoint="0"
            loading
            loading-text="Loading... Please wait"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon
              @click="onEditItem(item)"
            >
              mdi-circle-edit-outline
            </v-icon>
            <v-icon
              style="margin-right: 7px"
              @click="onDeleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn
              color="primary"
              @click="initialize"
            >
              Reset
            </v-btn>
          </template>
        </v-data-table>

        <!-- modal login-->
        <b-modal
          ref="modal-addServer"
          cancel-variant="outline-secondary"
          ok-title="افزودن"
          cancel-title="بستن"
          centered
          title="سرور جدید"
        >
          <b-form>
            <b-form-group
              label="عنوان:"
              label-for="vi-title"
            >
              <b-form-input
                id="vi-title"
                v-model="server.title"
                placeholder=""
              />
            </b-form-group>
            <b-form-group
              label="آدرس:"
              label-for="vi-url"
            >
              <b-form-input
                id="vi-url"
                v-model="server.url"
                placeholder=""
              />
            </b-form-group>
            <b-form-group
              label="آی پی:"
              label-for="vi-ip"
            >
              <b-form-input
                id="vi-ip"
                v-model="server.ip"
                placeholder=""
              />
            </b-form-group>
            <b-form-group
              label="پورت:"
              label-for="vi-port"
            >
              <b-form-input
                id="vi-port"
                v-model="server.port"
                placeholder=""
              />
            </b-form-group>
          </b-form>

          <template #modal-footer="">
            <b-button
              size="sm"
              variant="danger"
              @click="hideModal"
            >
              بستن
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="modalOk()"
            >
              ذخیره
            </b-button>
          </template>
        </b-modal>
    </b-card>
  </section>

</template>
<script>
import {
   BCard, BRow,BCol, BCardBody, BCardHeader, BButton, BModal, BForm, BFormInput, BFormGroup, BFormSelect, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import router from '@/router'
import serverService from '@/services/server.service'
import Server from '@/models/server'
import BreadcrumbMobile from '@/layouts/breadcrumb.vue'
import Vue from 'vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BModal,
    BButton,
    BCardBody,
    BCardHeader,
    BForm,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BInputGroup,
    BInputGroupPrepend,
  },
  data() {
    return {
      server: new Server('', '', '', '', ''),
      desserts: [],
      selected: '',
      options: [],
      isMobile: Vue.prototype.$functions.isMobile(),
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'عنوان',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        { text: 'آی پی', value: 'ip' },
        { text: 'آدرس', value: 'url' },
        { text: 'پورت', value: 'port' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
  },
  async mounted() {
    this.initializeOption()
  },
  async created() {
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    initializeOption() {
      try {
        serverService.getList({ type: 0 }).then(
          res => {
            if (res.status === 'success') {
              if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
                this.options = res.result.data
              } else {
                this.options = []
              }
            }
          },
        )
      } catch (err) {
        // console.log(err)
      }
    },
    initialize() {
      serverService.getList().then(
        res => {
          if (res.status === 'success') {
            this.desserts = []
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i <= res.result.data.length - 1; i++) {
                this.desserts.push(res.result.data[i])
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addClick() {
      router.push({ path: '/admin/manager/add' })
    },
    async modalOk() {
      await serverService.add(this.server)
        .then(
          res => {
            if (res.status === 'success') {
              this.$refs['modal-addServer'].hide()
              this.initialize()
              this.message = ''
            } else {
              this.message = res.message
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
          },
        )
      if (this.message) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'register error',
            text: this.message,
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      }
    },
    onDeleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('آیا مطمئنید؟')) {
        serverService.delete({
          // eslint-disable-next-line no-underscore-dangle
          _id: this.desserts[index]._id,
        }).then(
          res => {
            if (res.status !== 'success') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: res.result,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {
        index = ''
      }
    },
    onEditItem(item) {
      const index = this.desserts.indexOf(item)
      // this.server = this.desserts[index]
      // eslint-disable-next-line no-underscore-dangle
      this.server._id = this.desserts[index]._id.toString()
      this.server.title = this.desserts[index].title.toString()
      this.server.url = this.desserts[index].url.toString()
      this.server.ip = this.desserts[index].ip.toString()
      this.server.port = this.desserts[index].port.toString()
      this.$refs['modal-addServer'].show()
      // router.push({ name: 'admin-manager-edit', params: { id } })
    },
    showModal() {
      this.server = new Server('', '', '', '', '')
      this.initializeOption()
      this.$refs['modal-addServer'].show()
    },
    hideModal() {
      this.$refs['modal-addServer'].hide()
    },
  },
}
</script>
